<template>
    <!-- The landing screen: sports-center info up top, the member's statistics below. Both sections are the
         existing self-contained views, each loading its own data on mount. -->
    <div>
        <SportsCenterView />
        <StatisticsView />
    </div>
</template>

<script>
import SportsCenterView from '@/views/SportsCenterView.vue';
import StatisticsView from '@/views/StatisticsView.vue';

export default {
    name: 'HomeView',
    components: { SportsCenterView, StatisticsView }
};
</script>
